import React from 'react';

/**
 * RadioElement - Independent radio button group component
 * Fully self-contained with no external layout dependencies
 */
const RadioElement = ({ element, mode = 'form' }) => {
  const { content } = element;
  const {
    label = 'Radio Group',
    name = '',
    options = ['Option 1', 'Option 2'],
    required = false,
    helpText = ''
  } = content || {};

  // Generate field name from label if not provided
  const fieldName = name || label.toLowerCase().replace(/[^a-z0-9]+/g, '_');

  return (
    <div className="form-field" style={{ width: '100%', boxSizing: 'border-box' }}>
      {label && (
        <div className="form-label" style={{ marginBottom: '0.5rem' }}>
          {label}
          {required && <span className="form-required"> *</span>}
        </div>
      )}
      <div className="form-radio-group" role="radiogroup" aria-required={required}>
        {options.map((option, index) => {
          const optionId = `${fieldName}_${index}`;
          return (
            <label key={index} className="form-radio-label" htmlFor={optionId}>
              <input
                type="radio"
                id={optionId}
                name={fieldName}
                value={option}
                className="form-radio"
                required={required && index === 0}
                aria-required={required}
              />
              <span className="form-radio-text">{option}</span>
            </label>
          );
        })}
      </div>
      {helpText && (
        <p
          id={`${fieldName}-help`}
          className="form-help-text"
          style={{ fontSize: '0.875rem', color: 'var(--color-text-tertiary)', marginTop: '0.25rem' }}
        >
          {helpText}
        </p>
      )}
    </div>
  );
};

export default RadioElement;
